var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 8.75915L17.5704 8.7592C17.5893 8.77814 17.6 8.80388 17.6 8.83074V17.4987C17.6 17.5547 17.5547 17.6 17.4987 17.6H6.50126C6.44532 17.6 6.4 17.5547 6.4 17.4987V6.50126C6.4 6.44534 6.44534 6.4 6.50126 6.4H15.1692C15.1961 6.4 15.2218 6.41067 15.2408 6.42967L17.5703 8.75915ZM13.9043 11.9H14.2972L14.3042 11.5072L14.3458 9.18569L14.3531 8.77852H13.9459H8.97877H8.57877V9.17852V11.5V11.9H8.97877H13.9043Z",
    stroke: "#0A28AB",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTransparent);
export default __webpack_public_path__ + "res/media/saveTransparent.0c141ccca98eeedb33107b8cd4490852.svg";
export { ForwardRef as ReactComponent };